// src/components/results/ResultsModeSlider.jsx
import React, { memo, useMemo } from "react";

export default memo(function ResultsModeSlider({
  value,
  onChange,
  items,
  className = "",
  ariaLabel = "Results mode selector",
}) {
  const selectedIndex = useMemo(() => {
    const idx = items.findIndex((i) => i.value === value);
    return idx >= 0 ? idx : 0;
  }, [items, value]);

  return (
    <div className={`w-full ${className}`}>
      <div
        className="relative w-full rounded-xl bg-greyscale-1 overflow-hidden"
        role="tablist"
        aria-label={ariaLabel}
      >
        <div
          className="absolute top-0 bottom-0 transition-transform duration-200 ease-out"
          style={{
            width: `${100 / items.length}%`,
            transform: `translateX(${selectedIndex * 100}%)`,
          }}
        >
          <div className="h-full w-full bg-primary rounded-xl" />
        </div>

        <div
          className="relative grid"
          style={{
            gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`,
          }}
        >
          {items.map((item) => {
            const isActive = item.value === value;

            return (
              <button
                key={item.value}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => onChange?.(item.value)}
                className={[
                  "flex flex-col items-center justify-center gap-1 transition-colors py-1",
                  !isActive ? "text-primary" : "text-greyscale-1",
                ].join(" ")}
              >
                {/* Force icon SVG to use currentColor without touching icon component */}
                <span
                  className={[
                    "h-6 w-6 flex items-center justify-center",
                    // this is the key bit:
                    "[&_svg]:w-full [&_svg]:h-full [&_svg]:fill-current [&_svg]:stroke-current",
                  ].join(" ")}
                >
                  {item.icon}
                </span>

                {/* <span className="text-sm font-semibold">{item.label}</span> */}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
});
